import React, { useEffect, useState } from 'react';
import SelectionCard from './SelectionCard';
import './PopularItemSearch.css';
import { getPopularItems, searchPopularItems } from "./services/apiService"
import SearchResultsContainer from './SearchResultsContainer';
import { useConfig } from "./ConfigContext";

function PopularItemSearch({ requestConfig, setError }) {
  const config = useConfig()
  const titleStyle = { fontWeight: 'bold', fontSize: '0.8em', marginBottom: 8 };

  const [isLoading, setIsLoading] = useState(false);

  const [items, setItems] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const [query, setQuery] = useState('');
  const [originalQuery, setOriginalQuery] = useState('');
  const [data, setData] = useState([]);
  const [accordionInfo, setAccordionInfo] = useState(null)

  const [fromPosition, setFromPosition] = useState(0);

  useEffect(() => {
    items.length === 0 && handleGetPopularItems()
  }, [items]);

  const handleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((itemId) => itemId !== id)
        : [...prev, id]
    );
  };

  const handlePopularSearch = async (fromPos) => {
    resetState()
    try {
      setIsLoading(true)
      const data = await searchPopularItems(config, requestConfig, fromPos, { ids: selectedIds })

      setData(data?.output?.documents || [])
      setOriginalQuery(data?.output?.original_query || '')
      setQuery(data?.output?.query || '')
      setAccordionInfo(null)
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError(err.message);
    }
  };

  const handleDiscoverRecommendations = async () => {
    handlePopularSearch(0)
  };

  const handleGetPopularItems = async () => {
    setIsLoading(true);
    try {
      const items = await getPopularItems(config)
      setItems(items);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError(err.message);
    }
  }

  const handlePreviousPage = async () => {
    const newFromPos = Math.max(0, fromPosition - requestConfig.maxResults);
    setFromPosition(newFromPos);
    await handlePopularSearch(newFromPos)
  };

  const handleNextPage = async () => {
    const newFromPos = fromPosition + requestConfig.maxResults;
    setFromPosition(newFromPos);
    await handlePopularSearch(newFromPos)
  };

  const resetState = () => {
    setQuery('')
    setOriginalQuery('')
    setData([])
    setAccordionInfo(null)
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  const handleReset = () => {
    resetState()
    setFromPosition(0)
    setSelectedIds([])
  };

  return (
    <>
      {data.length === 0 && (
        <div className="popular-item-search">
          {isLoading && (<div className='loading-container'><div className="spinner"></div></div>)}

          {!isLoading && items.length > 0 && (
            <>
              <div style={titleStyle}>Wähle deine Favoriten und entdecke passende Inhalte für dich!</div>
              <div className="card-list">
                {items.map(item => (
                  <SelectionCard
                    key={item.id || item.title || item.name}
                    selected={selectedIds.includes(item.id)}
                    onSelect={() => handleSelect(item.id)}
                    title={item.title || item.name}
                    image={item.teaser_image_url}
                    description={item.description || item.teaser_text || "Keine Beschreibung verfügbar."}
                    link={null}
                    showTitle={item.show_title || ""}
                  />
                ))}
              </div>
              <div style={{ textAlign: "center", marginTop: 32 }}>
                <button
                  className='popular-items-btn'
                  disabled={selectedIds.length === 0}
                  onClick={handleDiscoverRecommendations}
                >
                  Inhalte entdecken
                </button>
            </div>
            </>

          )}
        </div>
      )}
      {data.length > 0 && (
        <SearchResultsContainer
          items={data}
          query={query}
          originalQuery={originalQuery}
          selectedFeature={'popular'}
          aiSearchMode={null}
          accordionInfo={accordionInfo}
          fromPosition={fromPosition}
          maxResults={requestConfig.maxResults}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          showPagination
          handleReset={handleReset}
        />
      )}
    </>

  );
}

export default PopularItemSearch;
